// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin-top:0}.default-wrapper.logo-wrapper{padding:25px}", ""]);
// Exports
module.exports = exports;
